import type { InputHTMLAttributes, ReactNode } from 'react';

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  hint?: ReactNode;
  error?: string | null;
}

export default function FormField({
  id,
  label,
  hint,
  error,
  className,
  ...inputProps
}: FormFieldProps) {
  // Inset well on the brand-dark card: deep-purple field, hairline
  // border, orange focus ring.
  const baseInputClass =
    'block w-full min-h-touch rounded-md border px-3.5 py-2.5 text-sm ' +
    'bg-brand-purple-deep/60 text-brand-cream border-white/10 ' +
    'placeholder:text-dark-muted ' +
    'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-brand-orange/60';
  const errorClass = error ? ' border-error focus:border-error focus:ring-error' : '';
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-brand-cream mb-1.5">
        {label}
      </label>
      <input
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
        className={baseInputClass + errorClass}
        {...inputProps}
      />
      {error ? (
        <p id={`${id}-error`} className="mt-1.5 text-xs text-error">
          {error}
        </p>
      ) : hint ? (
        <p id={`${id}-hint`} className="mt-1.5 text-xs text-dark-muted">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
